import React from 'react'

import OfferPage from './OfferPage'
import ViewToggle from '../../subcomponents/ViewToggle'

const BasicOfferPage = props => {
    return (
        <ViewToggle isMobile={props.isMobile('web')}>
            <OfferPage
                {...props}
                campaign={props.campaign}
                footnotes={props.campaign.footnotes}
                bigIndices={props.bigIndices}
            />
        </ViewToggle>
    )
}

export default BasicOfferPage



// WEBPACK FOOTER //
// ./src/components/ads/mam3/BasicOfferPage.js